module.exports = __webpack_public_path__ + "img/velaine-concours.93f2c5d.png";